import { render, staticRenderFns } from "./adviceForHelp.vue?vue&type=template&id=7b38d90e&scoped=true&"
import script from "./adviceForHelp.vue?vue&type=script&lang=js&"
export * from "./adviceForHelp.vue?vue&type=script&lang=js&"
import style0 from "./adviceForHelp.vue?vue&type=style&index=0&id=7b38d90e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b38d90e",
  null
  
)

export default component.exports